import { size } from 'lodash';

export const NavMain = {
  bindings: {
    items: '<',
    avatarSrc: '<',
    product: '<',
    subscriptions: '<',
    subscription: '<',
    onClickSubscription: '&',
  },

  template: `
    <nav class="navbar navbar-expand-lg navbar-dark theme-dark py-md-0 navbar--main">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center w-100 w-lg-0">
          <div class="left-content">
            <button class="navbar-toggler mr-3 border-0 p-0"
              ng-show="$ctrl.items.length > 1 || $ctrl.subscriptonsLength > 1"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <button class="navbar-brand navbar-brand--icon btn btn-link border-0 py-lg-0 pl-0"
              type="button"
              ng-click="$ctrl.onClickSubscription({ subscription: $ctrl.subscription })">
              <nav-logo></nav-logo>
            </button>
          </div>
          <div class="d-lg-none">
            <a class="btn btn-link p-0" ui-sref="profile">
              <image-circle src="$ctrl.avatarSrc"></image-circle>
            </a>
          </div>
        </div>
        <div id="navbarCollapse" class="collapse navbar-collapse">
          <ul class="navbar-nav navbar-nav--list mr-auto align-self-end">
            <li class="nav-item mr-3"
              ng-repeat="item in $ctrl.items track by $index">
              <small class="nav-upgrade text-uppercase text-green"
                ng-if="item.upgrade">
                Upgrade
              </small>
              <nav-item
                child-path="item.childPath"
                icon="item.icon"
                path="item.path"
                title="item.title">
              </nav-item>
            </li>
            <li class="nav-item d-lg-none mb-3">
              <nav-dropdown
                ng-if="$ctrl.subscriptonsLength > 1"
                product="$ctrl.product"
                subscriptions="$ctrl.subscriptions"
                on-click="$ctrl.onClickSubscription({ subscription: subscription })">
              </nav-dropdown>
            </li>
          </ul>
          <ul class="navbar-nav d-none d-lg-flex align-items-lg-center divider-left divider-right">
            <li class="nav-item dropdown px-lg-2"
              ng-class="{ 'd-none d-md-block': $ctrl.subscriptonsLength === 1 }">
              <nav-product-title
                ng-if="$ctrl.subscriptonsLength === 1"
                title="$ctrl.product.name"
                first-name="$ctrl.product.author.firstName"
                last-name="$ctrl.product.author.lastName">
              </nav-product-title>
              <nav-dropdown
                ng-if="$ctrl.subscriptonsLength > 1"
                product="$ctrl.product"
                subscriptions="$ctrl.subscriptions"
                on-click="$ctrl.onClickSubscription({ subscription: subscription })">
              </nav-dropdown>
            </li>
            <li class="nav-item p-2 divider-left">
              <a class="btn btn-link d-none d-md-block p-lg-0"
                ui-sref="profile">
                <image-circle src="$ctrl.avatarSrc"></image-circle>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>`,

  controller($ngRedux, $state) {
    'ngInject';

    return {
      $onInit() {
        this.navBarCollapse = $('#navbarCollapse')
          .on('show.bs.collapse', () => this.subscribe())
          .on('hide.bs.collapse', () => this.unsubscribe());
      },

      $onDestroy() {
        this.unsubscribe && this.unsubscribe();
      },

      // Need to fix selectSubscriptions to return an array but requires
      // fixes to every method that uses selectSubscriptions.
      $onChanges({ subscriptions }) {
        this.subscriptonsLength = size(subscriptions.currentValue);
      },

      subscribe() {
        const href = this.getRouterHref();

        this.unsubscribe = $ngRedux.subscribe(() => {
          if (href !== this.getRouterHref()) {
            this.unsubscribe();
            this.navBarCollapse.collapse('hide');
          }
        });
      },

      getRouterHref() {
        const {
          currentState,
          currentParams,
          href,
        } = $ngRedux.getState().router;

        return href(currentState.name, currentParams);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavMain.js